import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    sampleNumber: Yup.string().required("Sample Number is Required"),
    pumpNumber: Yup.string().nullable(),
    sampleType: Yup.string().nullable(),
    exposureTimeOn: Yup.string().nullable(),
    exposureTimeOff: Yup.string().nullable(),
    nonExposureTime: Yup.number().nullable(),
    preCalibration: Yup.number().nullable(),
    postCalibration: Yup.number().nullable(),
    sampleInformation: Yup.string().nullable(),
    workerId: Yup.string().nullable(),
    ppe: Yup.string().nullable(),
    dateTime: Yup.date().nullable()
});

